import { InputLabel, MenuItem, Select, OutlinedInput, Skeleton } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function EntriesSelect({ id, label, options = [], renderValueKey, selectLabel, varianttype, loading = false, ...rest }) {
  id = id || uid(6)

  return (
    <Fragment>
      {label &&
        <InputLabel htmlFor={id}>{label}</InputLabel>
      }
      {loading ?
        <Skeleton
          sx={{
            width: "100%",
            height: "100%",
            transform: "none",
            maxHeight: "40px",
          }}
        /> :
        <Select
          fullWidth
          size="small"
          defaultValue={10}
          renderValue={(option) => option}
          input={<OutlinedInput id={id} />}
          {...rest}
        >
          {[10, 25, 50, 100]?.map((option, i) => (
            <MenuItem
              sx={{
                color: "black",
                fontSize: "14px",
                fontFamily: "Poppins",
                textTransform: "capitalize"
              }}
              key={i}
              value={option}
              disableRipple
            >{option}
            </MenuItem>
          ))}
        </Select>
      }
    </Fragment>
  )
}

export default EntriesSelect